// A simple results card drawer component that can be used to display a list of results in a drawer on the right half of the screen
// The chevron icon is used to close the drawer, this hangs off the edge and is always visible

import React, { useContext } from 'react'

import { store } from '../../store/app/Store'
import ListingsSection from '../results-section/ListingsSection'

const ResultsDrawer = (props) => {
  const globalState = useContext(store)
  const { state } = globalState

  return (
    <>
      <div
        style={{
          width: state.resultsSection.open ? '50%' : '0%',
          background: '#E9F5FE',
          transition: 'width 0.3s ease',
          top: `118px`,
          height: '-webkit-fill-available',
          position: 'absolute',
          right: 0,
          zIndex: 100,
          overflow: 'auto',
        }}
      >
        {state.resultsSection.open && <ListingsSection />}
      </div>
    </>
  )
}

export default ResultsDrawer
